export default __webpack_public_path__ + "static/media/b8.0ca6afe1.png";